import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Image, Wrench, Mail, Sparkles } from "lucide-react";

const NotFound = () => {
  const navLinks = [
    { name: "Inicio", path: "/", icon: Home },
    { name: "Servicios", path: "/servicios", icon: Wrench },
    { name: "Galería", path: "/galeria", icon: Image },
    { name: "Contacto", path: "/contacto", icon: Mail },
  ];

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <motion.div
        className="text-center max-w-2xl"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <Sparkles className="w-12 h-12 text-[#00A8FF]" />
          <span className="text-4xl font-black tracking-tighter uppercase">
            <span className="text-white">Brill</span>
            <span className="text-[#00A8FF]">ox</span>
          </span>
        </div>

        {/* 404 Message */}
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h1 className="text-[150px] md:text-[200px] font-black text-white/10 leading-none">
            404
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-wider -mt-8 mb-4">
            Página No Encontrada
          </h2>
          <p className="text-white/60 text-lg mb-12">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
        </motion.div>

        {/* Navigation Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {navLinks.map((link, index) => (
            <motion.div
              key={link.path}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
            >
              <Link
                to={link.path}
                className="block glass-card p-6 hover:bg-[#00A8FF]/10 transition-all duration-300 group"
              >
                <link.icon className="w-8 h-8 text-[#00A8FF] mb-3 mx-auto group-hover:scale-110 transition-transform" />
                <span className="text-white font-semibold uppercase text-sm tracking-wider">
                  {link.name}
                </span>
              </Link>
            </motion.div>
          ))}
        </div>

        {/* Back to Home Button */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <Link
            to="/"
            className="inline-block btn-skew bg-[#00A8FF] text-[#050505] px-8 py-4 font-bold uppercase tracking-widest hover:shadow-[0_0_30px_rgba(0,168,255,0.5)] transition-all duration-300"
          >
            <span>Volver al Inicio</span>
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFound;
